<template>
  <div class="draw_address_toast_bg" v-show="toastShow">
    <div class="draw_address_toast_centent_bg">
      <div class="draw_address_toast_centent_header_bg">
        <div class="draw_address_toast_centent_header_title">中奖了</div>
        <div class="draw_address_toast_centent_header_title_name">
          {{ headerTitle }}
        </div>
      </div>
      <div class="draw_address_toast_addr_title">填写收件信息</div>
      <input
        class="draw_address_toast_addr_input"
        type="text"
        v-model="name"
        maxlength="10"
        @keyup.enter="inputName"
        @input="inputName()"
        placeholder="收件人姓名"
      />
      <input
        class="draw_address_toast_addr_input"
        type="text"
        v-model="phone"
        minlength="11"
        maxlength="11"
        @keyup.enter="inputPhone"
        @input="inputPhone()"
        oninput="value = value.replace(/[^0-9]/g,'')"
        placeholder="联系电话"
      />
      <textarea
        class="draw_address_toast_addr_input"
        maxlength="36"
        v-model="address"
        @keyup.enter="inputAdd"
        @input="inputAdd($event)"
        placeholder="收件地址"
      />
      <button
        :class="{ draw_address_toast_addr_button_red: isDown }"
        class="button draw_address_toast_addr_button"
        @click="redeemPrizes"
      >
        确定
      </button>
      <button
        class="button lottery_image_toast_close"
        @click="$emit('isshowaction')"
      >
        <img
          class="lottery_image"
          src="../../assets/lottery/close_icon.png"
          alt="关闭"
        />
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Options } from "vue-class-component";
import { Http } from "../../net/Http";
import { Urls } from "../../net/Urls";
import { openToast } from "toast-ts";
@Options({
  props: {
    headerTitle: String,
    toastShow: Boolean
  },
  emits: {
    isshowaction: () => {
      return true;
    },
    reloadData: () => {
      return true;
    }
  }
})
/*开奖时刻，首次进来，开奖,填写地址*/
export default class DrawAddressToast extends Vue {
  /// 确定的背景颜色
  isDown = false;
  name = "";
  phone = "";
  address = "";
  inputName() {
    this.isDownAction();
  }
  inputPhone() {
    this.isDownAction();
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  inputAdd(event: any) {
    event;
    this.isDownAction();
  }
  isDownAction() {
    if (
      this.name.length > 0 &&
      this.phone.length == 11 &&
      this.address.length > 0
    ) {
      this.isDown = true;
    } else {
      this.isDown = false;
    }
  }
  redeemPrizes() {
    if (!this.isDown) return;
    const data = {
      type: 1,
      contactPhone: this.phone,
      contactAddr: this.address,
      contactPerson: this.name
    };
    Http.post<string>(Urls.lottery_order, data).then(
      () => {
        openToast("兑换成功");
        // eslint-disable-next-line vue/custom-event-name-casing
        this.$emit("reloadData");
      },
      () => {
        openToast("兑换失败，查看具体原因，请联系客服。");
      }
    );
  }
}
</script>

<style scoped lang="less">
@import "../../style/BaseStyle.less";
.draw_address_toast_bg {
  position: fixed;
  z-index: 2000;
  left: 0px;
  right: 0;
  top: 44px;
  bottom: 0;
  text-align: center;
  background: rgba(17, 17, 17, 0.7);
  height: 100%;
  width: 100%;
  .draw_address_toast_centent_bg {
    width: 325px;
    height: 446px;
    position: fixed;
    z-index: 2100;
    left: 50%;
    top: 50%;
    transform: translateX(-50%) translateY(-50%);
    text-align: center;
    border-radius: 10px;
    background-color: white;
    .draw_address_toast_centent_header_bg {
      background-color: #f64746;
      border-radius: 10px 10px 0px 0px;
      padding-bottom: 1px;
      .draw_address_toast_centent_header_title {
        padding: 0px 0px 0px 0px;
        margin: 0px 0px 0px 0px;
        margin-left: 25%;
        margin-right: 25%;
        color: #ffffff;
        font-weight: bold;
        background-color: #e13635;
        border-radius: 0px 0px 200px 200px;
        padding-top: 8px;
        padding-bottom: 6px;
      }
      .draw_address_toast_centent_header_title_name {
        margin: 20px 20px 20px 20px;
        border-radius: 10px;
        font-size: 14px;
        color: #ffffff;
        text-align: left;
        padding: 5px 10px 5px 10px;
        background-color: rgba(255, 255, 255, 0.16);
      }
    }
    /// 输入框
    .draw_address_toast_addr_title {
      text-align: left;
      margin-top: 20px;
      margin-left: 20px;
      margin-right: 20px;
      font-weight: bold;
      font-size: 14px;
    }
    .draw_address_toast_addr_input {
      width: 255px;
      margin-top: 10px;
      padding: 15px 15px 15px 15px;
      background-color: #f6f6f6;
      border: 0px solid transparent;
      border-radius: 5px;
      outline: none; // 去除选中状态边框
      word-wrap: break-word;
      font-size: 14px;
    }
    .draw_address_toast_addr_button {
      padding: 10px 85px;
      background-color: #cccccc;
      font-size: 15px;
      color: #ffffff;
      border-radius: 30px;
      margin-top: 20px;
    }
    .draw_address_toast_addr_button_red {
      background-color: #f64746;
    }
    .lottery_image_toast_close {
      position: fixed;
      z-index: 2200;
      left: 50%;
      bottom: -70px;
      color: #ffffff;
      transform: translateX(-50%) translateY(-50%);
      text-align: center;
      .lottery_image {
        width: 36px;
        height: 36px;
      }
    }
  }
}
</style>
